import { getCurrentYear } from '../../utils';

export const copyrightYearValue = `© ${getCurrentYear()} `;
const PrivacyPolicyLink = 'https://sites.disney.com/ngr-privacy-policy';

export const LINKS = {
  privacyPolicy: PrivacyPolicyLink,
  betaTerms: 'https://disneycampaignmanager.com/hulu-ad-manager-beta-terms',
  terms: 'https://disneycampaignmanager.com/disney-campaign-manager-terms',
};

export const BAYMAX_LINKS = {
  terms: 'https://www.disneycampaignmanager.com/disney-campaign-manager-terms',
  portalTerms: 'https://www.disneyadvertising.com/disney-client-reporting-portal-terms',
  caNotice: 'https://sites.disney.com/ngr-privacy-policy/#cali-notice-at-collection',
};
